import React from 'react';
import Fab from '@material-ui/core/Fab';
import type { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import { colors, elevation } from '@skyslope/mache';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    marginTop: theme.spacing(2),
    boxShadow: elevation.normal[12],
    backgroundColor: 'white',
    color: colors.blue[800],
    '&:hover': {
      backgroundColor: 'white',
    },
  },
}));

interface IProps {
  disabled?: boolean;
  children?: any;
  onClick: () => void;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const TextButton = (props: IProps) => {
  const classes = useStyles();
  return (
    <Fab
      className={classes.button}
      disabled={props.disabled}
      onClick={() => props.onClick()}
      size="small"
      disableRipple
      disableFocusRipple
    >
      {props.children}
    </Fab>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default TextButton;
